const dataRender = ({ value }) => {
  const sum = value.reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0
  );
  return sum;
};

const monthsRender = ({ value }) => {
  return <div>{value.join(',')}</div>;
};

const ReportsColumns = [
  { name: 'agency', header: 'Agency', minWidth: 200, flex: 1, resizable: true },
  { name: 'totalPO', header: 'Total PO', minWidth: 120, flex: 1, resizable: true },
  {
    name: 'totalRfqReceived',
    header: 'Total RFQ Received',
    minWidth: 150,
    flex: 1,
    resizable: true,
  },
  {
    name: 'totalRfqResponses',
    header: 'Total RFQ Responses',
    minWidth: 150,
    flex: 1,
    resizable: true,
  },
  {
    name: 'totalPoCost',
    header: 'Total PO Cost',
    minWidth: 150,
    flex: 1,
    resizable: true,
  },
  {
    name: 'totalRfqCost',
    header: 'Total RFQ Cost',
    minWidth: 150,
    flex: 1,
    resizable: true,
  },
  {
    name: 'projMargin',
    header: 'Projected Margin',
    minWidth: 150,
    flex: 1,
    resizable: true,
  },
  {
    name: 'totalFinalPoCost',
    header: 'Total Final PO Cost',
    minWidth: 150,
    flex: 1,
    resizable: true,
  },
  {
    name: 'actualMargin',
    header: 'Actual Margin',
    minWidth: 130,
    flex: 1,
    resizable: true,
  },
  { name: 'taxes', header: 'Taxes', minWidth: 120, flex: 1, resizable: true },
  { name: 'profit', header: 'Profit', minWidth: 120, flex: 1, resizable: true },
  { name: 'months', header: 'Months', minWidth: 100, flex: 1, resizable: true },
  {
    name: 'vpoInvoices',
    header: 'VPO Invoices',
    minWidth: 130,
    flex: 1,
    resizable: true,
  },
  {
    name: 'totalSpoInvoices',
    header: 'Total SPO Invoices',
    minWidth: 150,
    flex: 1,
    resizable: true,
  },
];

export const TotalsColumns = [
  { name: 'agency', header: 'Total', minWidth: 200, flex: 1, resizable: true },
  { name: 'totalPO', header: 'Total PO', minWidth: 120, flex: 1, resizable: true },
  { name: 'totalRfqReceived', header: 'Total RFQ Received', minWidth: 150, flex: 1, resizable: true },
  { name: 'totalRfqResponses', header: 'Total RFQ Responses', minWidth: 150, flex: 1, resizable: true },
  { name: 'totalPoCost', header: 'Total PO Cost', minWidth: 150, flex: 1, resizable: true },
  { name: 'totalRfqCost', header: 'Total RFQ Cost', minWidth: 150, flex: 1, resizable: true },
  { name: 'projMargin', header: 'Projected Margin', minWidth: 150, flex: 1, resizable: true },
  { name: 'totalFinalPoCost', header: 'Total Final PO Cost', minWidth: 150, flex: 1, resizable: true },
  { name: 'actualMargin', header: 'Actual Margin', minWidth: 130, flex: 1, resizable: true },
  { name: 'taxes', header: 'Taxes', minWidth: 120, flex: 1, resizable: true },
  { name: 'profit', header: 'Profit', minWidth: 120, flex: 1, resizable: true },
  {
    name: 'months',
    header: 'Months',
    minWidth: 100,
    flex: 1,
    resizable: true,
    render: () => <span></span>,
  },
  { name: 'vpoInvoices', header: 'VPO Invoices', minWidth: 130, flex: 1, resizable: true },
  { name: 'totalSpoInvoices', header: 'Total SPO Invoices', minWidth: 150, flex: 1, resizable: true },
];

export const ItemsColumns = [
  { name: 'itemName', header: 'Item Name', minWidth: 250, flex: 2, resizable: true },
  { name: 'qty', header: 'Quantity', minWidth: 100, flex: 1, resizable: true },
  {
    name: 'totalPoCost',
    header: 'Total LI Purchase Cost',
    minWidth: 180,
    flex: 1,
    resizable: true,
    render: ({ value }) => value.toFixed(2),
  },
  {
    name: 'totalFinalPoCost',
    header: 'Total PO Cost',
    minWidth: 180,
    flex: 1,
    resizable: true,
    render: ({ value }) => value.toFixed(2),
  },
  {
    name: 'margin',
    header: 'Margin',
    minWidth: 120,
    flex: 1,
    resizable: true,
    render: ({ value }) => value.toFixed(2),
  },
  {
    name: 'profit',
    header: 'Profit',
    minWidth: 150,
    flex: 1,
    resizable: true,
    render: ({ value }) => value.toFixed(2),
  },
];

export const ItemsTotalColumns = [
  { name: 'itemName', header: 'Total', minWidth: 250, flex: 2, resizable: true },
  { name: 'qty', header: 'Quantity', minWidth: 100, flex: 1, resizable: true },
  {
    name: 'totalPoCost',
    header: 'Total LI Purchase Cost',
    minWidth: 180,
    flex: 1,
    resizable: true,
    render: ({ value }) => value.toFixed(2),
  },
  {
    name: 'totalFinalPoCost',
    header: 'Total PO Cost',
    minWidth: 180,
    flex: 1,
    resizable: true,
    render: ({ value }) => value.toFixed(2),
  },
  {
    name: 'margin',
    header: 'Margin',
    minWidth: 120,
    flex: 1,
    resizable: true,
    render: ({ value }) => value.toFixed(2),
  },
  {
    name: 'profit',
    header: 'Profit',
    minWidth: 150,
    flex: 1,
    resizable: true,
    render: ({ value }) => value.toFixed(2),
  },
];

export default ReportsColumns;
